import { initialState } from '../../betSlip';
import type { BetSlipState } from '../../types/betSlip';
import { isAvailableOpportunity } from '../../utils/betSlip/isOpportunity';

const priceChangesAccepted = (
  state: BetSlipState,
  opportunities: BetSlipState['opportunities']
): BetSlipState => ({
  ...state,
  opportunities,
  receipt: initialState.receipt,
  acceptedOdds: [...opportunities.SINGLE, ...opportunities.MULTIPLE].reduce<
    BetSlipState['acceptedOdds']
  >((acc, next) => {
    acc[next.id] = isAvailableOpportunity(next) ? next.winRunnerOdds : undefined;

    return acc;
  }, {})
});

export default priceChangesAccepted;
